module.exports = __webpack_public_path__ + "static/media/icon-proportional.61ac73e1.svg";